import api from '../../index'

const { http } = api

/**
 * ===================
 * Work History AI Generation API
 * ===================
 */
export default {
  baseUrl: `${process.env.VUE_APP_CUSTOMER_URL}/api/v2/applicant`,
  url: 'work-histories/generate-ai',
  http,

  /**
   * Generate AI work history text
   *
   * @param {Object} payload
   * @param {string} payload.job_position - Job title from the registration form
   * @param {string} payload.role - Role from the registration form
   * @param {string} payload.brief_description - Free text entered by the customer
   * @param {string} payload.language - 'ja' or 'en'
   * @param {number} payload.work_history_id - Client-generated ID to track per-project generation limits
   * @returns {Promise}
   */
  generate(payload) {
    return this.http(this.baseUrl).post(this.url, payload)
  }
}
